import { IconFlag } from 'components';
import React, { useMemo } from 'react';
import { SingleClientTaskRow } from './singleClientTaskRow';
import { formatDate } from 'utils/helpers';

export const ClientTasks = ({ client }) => {
  const storeTasks = useMemo(() => {
    const lastAssignedTask = [...(client?.tasks || [])].filter((t) => t.assigned_at).at(-1);
    const lastAssignedWeek = lastAssignedTask?.week ?? 0;
    const lastAssignedAt = lastAssignedTask?.assigned_at ?? null;

    const normalizedTasks = Array.from({ length: 6 }, (_, index) => {
      return (
        client?.tasks?.[index] ?? {
          completed: false,
          week: index + 1,
          task_id: null,
          form_id: null,
        }
      );
    });

    return normalizedTasks.map((task, index) => {
      return (
        <SingleClientTaskRow
          key={task.task_id || `week-${index + 1}`}
          weekIndex={index + 1}
          task={task}
          startDate={client.start_date}
          clientStatus={client.status}
          lastAssignedWeek={lastAssignedWeek}
          lastAssignedAt={lastAssignedAt}
          granted={client.granted[index]}
        />
      );
    });
  }, [client.granted, client.start_date, client.status, client.tasks]);

  return (
    client && (
      <div className="flex flex-col bg-white base-block mt-6">
        <div className='flex justify-between items-center p-[30px] relative border-b border-divider after:content-[""] after:absolute after:w-4 after:h-4 after:rounded-full after:border after:border-divider after:bg-white after:z-10 after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:translate-y-1/2'>
          <p className="nunito-title">Your Tasks</p>
          <div className="flex items-center gap-x-12">
            <div className="flex items-center bg-white p-1 pl-2 rounded-ten shadow-block-shadow-light">
              <IconFlag />
              <p className="text-14 ml-1.5 mr-3">Start</p>
              <div className="flex items-center bg-yellow py-1.5 px-3 rounded-md">
                <p className="text-14 font-bold">{formatDate(client?.start_date)}</p>
              </div>
            </div>
            <div className="flex items-center bg-white p-1 pl-2 rounded-ten shadow-block-shadow-light">
              <IconFlag />
              <p className="text-14 ml-1.5 mr-3">End</p>
              <div className="flex items-center bg-lightGreen py-1.5 px-3 rounded-md">
                <p className="text-14 font-bold">{formatDate(client.end_date)}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col py-5 px-[30px] gap-y-4">
          <div className="flex items-center">
            <p className="text-lightBlue text-14 w-[20%]">Week</p>
            <div className="w-4/5 flex items-center px-4 gap-x-8">
              <p className="w-1/4 text-lightBlue text-14">Forms</p>
              <p className="w-1/4 text-lightBlue text-14">Granted</p>
              <p className="w-1/4 text-lightBlue text-14">Assigned</p>
              <p className="w-1/4 text-lightBlue text-14">Status</p>
              <p className="w-1/4 text-lightBlue text-14" />
            </div>
          </div>
          {storeTasks}
          <div className="mt-4 flex items-center gap-x-6 self-end pb-4">
            <div className="flex items-center gap-x-2">
              <div className="w-3 h-3 rounded-full bg-green" />
              <p className="text-14">Completed</p>
            </div>
            <div className="flex items-center gap-x-2">
              <div className="w-3 h-3 rounded-full bg-orange" />
              <p className="text-14">Pending</p>
            </div>
            <div className="flex items-center gap-x-2">
              <div className="w-3 h-3 rounded-full bg-red" />
              <p className="text-14">Overdue</p>
            </div>
            <div className="flex items-center gap-x-2">
              <div className="w-3 h-3 rounded-full bg-grey" />
              <p className="text-14">Current / Upcoming</p>
            </div>
          </div>
        </div>
      </div>
    )
  );
};
